import React from 'react';
import { IconProps } from '../types';

export const Equipment: React.FC<IconProps> = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="32" fill="white" />
    <path
      d="M9.33337 16V25.0115C9.33337 25.924 9.78204 26.6667 10.3334 26.6667H11C11.5514 26.6667 12 25.924 12 25.0115V16H9.33337Z"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33333 16L12.6667 15.9997L17.3333 12.1905V2.66667L14.6667 2.667V9.0162C14.6667 9.55048 14.5515 9.65112 14 9.65112L12.6667 9.65079C12.1152 9.65079 12 9.55016 12 9.01587L12.0213 2.66667H9.33333V9.01587C9.33333 9.55016 9.21817 9.65079 8.66667 9.65079H7.33333C6.78183 9.65079 6.66667 9.55016 6.66667 9.01587V2.66667H4V12.1905L9.33333 16Z"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.3334 16H25.3334V4.44445C25.3334 3.34178 24.827 2.66667 24 2.66667H22.6667C21.8397 2.66667 21.3334 3.34178 21.3334 4.44445V16Z"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.5334 16L17.3334 18.0952L23.3334 30.6667L29.3334 18.0952L25.1334 16H21.5334Z"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
